// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const Dialog = (el) => {
  // dialog.jsx renders the trigger button as the <dialog>'s next sibling
  // (both are top-level children of the same Fragment); scoping to it here
  // avoids grabbing an unrelated dialog's trigger when multiple dialogs
  // exist on the page at once (e.g. a hideTrigger dialog rendered globally
  // alongside a story that has its own dialog + trigger).
  const nextSibling = el.nextElementSibling;

  const ui = {
    el,
    body: select('body', document),
    show: nextSibling && nextSibling.classList.contains('dialog-show') ? nextSibling : null,
    close: select('.dialog__close', el),
    confirm: select('.dialog__confirm', el),
    cancel: select('.dialog__cancel', el),
    video: select('.video', el),
    iframe: select('iframe', el),
  };
  
  const pauseVideoEmbed = () => {
    if (ui.iframe) {
      let iframeSrc = ui.iframe.src;
      ui.iframe.src = iframeSrc;
    } else if (ui.video) {
      ui.video.pause();
    }
  }

  const openDialog = () => {
    ui.el.showModal();
  };

  const closeDialog = () => {
    pauseVideoEmbed();
    ui.el.close();
  }

  const confirmation = () => {
    console.log('confirmation clicked');
    closeDialog();
  }

  const cancellation = () => {
    console.log('cancellation clicked');
  }

  const addEvents = () => {
    if (ui.show) {
      ui.show.addEventListener('click', () => {
        openDialog();
      });
    }
    if (ui.close) {
      ui.close.addEventListener('click', () => {
        closeDialog();
      });
    }
    if (ui.confirm) {
      ui.confirm.addEventListener('click', () => {
        confirmation();
      });
    }
    if (ui.cancel) {
      ui.cancel.addEventListener('click', () => {
        cancellation();
      });
    }
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default Dialog;
